import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export interface Subject {
    id: number;
    name: string;
    description: string;
    duration: number;
    image_url: string | null;
    created_on?: string;
    subtopicsCount?: number;
    [key: string]: any;
}

export const TopicSelectionSlice = createSlice({
    name: "TopicSelectionSlice",
    initialState: {} as IReduxState<Subject[]>,
    reducers: {
        getTopics: (state) => {
            state.isLoading = true;
        },
        successGetTopics: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failureGetTopics: (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        },
    },
});

export const { failureGetTopics, getTopics, successGetTopics } =
    TopicSelectionSlice.actions;

export default TopicSelectionSlice.reducer;
